export const getLocalStorageItem = (key: string) => {
	return window.sessionStorage.getItem(key) ?? '';
};

export const addLocalStorageEventListener = (eventKey: string, callback: () => void) => {
	window.addEventListener(`${eventKey}-event`, callback);
};
